import downLoadAllConfig from '@/js/modal/interfacePlatform/config/downLoadAll.Config.js';
import customizedService from '@/service/index.js';
import interceptorsModule from '@/config/interceptors'
import md5 from 'md5'

/* --------- config: --------- */
import configModule from '@/config/config';
/* --------- mixin: --------- */
import mixinsModule from '@/config/minxin';

import layoutModule from '@/component/commonPages/layout';

let keepAliveLabelMapsAll = JSON.parse(window.localStorage.getItem('keepAliveLabelMapsAll')|| '{}');
let menus = {}
for (const key1 in keepAliveLabelMapsAll) {
  const key2 = key1.substring(key1.indexOf(".")+1, key1.lastIndexOf("."));
  const id = key1.substring(key1.lastIndexOf(".")+1);
  menus[key2] = id;
}

// 接口拦截
R3.network.axios.interceptors.request.use((config) => {
  const { tableName } = vm.$route.params;
  if (config.url == '/api/cs/md/proGoods/save' && vm.$route.params.itemId == 'New') {
    const { IS_ONE_STYLE_ONE_CODE, data } = vm.$store.state.omsStore.addSKU
    let params = config.data;
    params.data[tableName].IS_ONE_STYLE_ONE_CODE = IS_ONE_STYLE_ONE_CODE
    params.data.PS_C_PRO_ITEM = data
    config.data = params;
  }

  if (config.url.includes('p/cs/') && !config.url.includes('/p/cs/permission/')) {
    const { fullPath, params: _pa } = vm.$route
    let tableId

    if (fullPath.includes('/CUSTOMIZED/')) {
      const page = _pa.customizedModuleName
      if (menus.hasOwnProperty(page)) {
          // 列表
        tableId = menus[page];
      } else {
        const all = OMS.cusPageConfig;
        if (all.hasOwnProperty(page)) {
          if (all[page].menuKey) {
            const key3 = all[page].menuKey.toLocaleUpperCase();
            if (menus.hasOwnProperty(key3)) {
              // 单对象
              tableId = menus[key3];
            }
          } else {
            console.error("Can't find menuKey！");
          }
        }
      }
    } else if (fullPath.includes('/SYSTEM/')) {
      tableId = _pa.tableId
    }
    if (tableId) {
      let newTime = new Date().getTime();
      let sessionCookie = window.localStorage.getItem('sessionCookie')
      config.headers['SSSSS-A'] = newTime
      if (sessionCookie === 'undefined') {
        config.headers['SSSSS-B'] = md5('qwertburgeon' + newTime + tableId)
      } else {
        config.headers['SSSSS-B'] = md5('qwertburgeon' + newTime + tableId + sessionCookie)
      }
      config.headers['SSSSS-C'] = tableId
    }
  }

  interceptorsModule.category.request(config) // defined商品品类
  interceptorsModule.SG_B_STO_X_RESULT.request(config) // 逻辑出库单/逻辑入库单新增

  if (config.url == '/p/cs/inputForitem') {
    let configData = decodeURIComponent(config.data.toString());
    if (configData.includes('OC_B_VIPCOM_DISTRIBUTION_ITEM')) {
      let params = new URLSearchParams();
      configData.split('&').forEach((i) => {
        const [key, val] = i.split('=');
        params.append(key, val);
      });
      params.append('date', +new Date());
      config.data = params;
    }
  }
  if (config.url == '/p/cs/newQueryList') {
    if (vm.$route.fullPath.includes("/SYSTEM/TABLE_DETAIL/V/SG_C_PERCENT_STRATEGY")) {
      // 【百分比分货策略】【目标配销仓明细】中配销仓过滤，只可以选择主表聚合仓下的记录
      if (config.data.toString().includes('1700862441')) {
        let configData = decodeURIComponent(config.data.toString());
        const s_store = vm.$_live_getChildComponent(vm, `${vm.$route.params.tableName}SG_C_SHARE_STORE_ID`)
        if (s_store.value && s_store.value.length) {
          // 聚合仓有值
          const obj = {
            fixedcolumns: {
              SG_C_SHARE_STORE_ID: s_store.value[0].ID
            }
          };
          configData.split('&').forEach((i) => {
            const [key, val] = i.split('=');
            if (key == 'searchdata') {
              Object.assign(obj, JSON.parse(val));
            } else {
              obj[key] = val;
            }
          });
          let params = new URLSearchParams();
          params.append('searchdata', JSON.stringify(obj));
          config.data = params;
        }
      }
    }
  }
  if (config.url == '/p/cs/objectTableItem') {
    // 门店配货计划 - 门店配货计划明细
    if (tableName == 'SG_B_STO_STORE_DISTRIBUTION') {
      let configData = decodeURIComponent(config.data.toString());
      if (configData.includes('SG_B_STO_STORE_DISTRIBUTION_ITEM')) {
        let params = new URLSearchParams();
        const obj = {};
        configData.split('&').forEach((i) => {
          const [key, val] = i.split('=');
          if (key == 'searchdata') {
            Object.assign(obj, JSON.parse(val));
          } else {
            obj[key] = val;
          }
        });
        localStorage.setItem('storeDistributionPageSize', obj.range)
        params.append('searchdata', JSON.stringify(obj));
        config.data = params;
        config.url = '/api/cs/sg/storeDistribution/QueryList';
      }
    }
  }
  if (config.url == '/p/cs/screenresult') {
    let globalInput = $('.test-daigo .dialog_center .dialog_center_bottom .ark-input-wrapper .ark-input');
    if (globalInput.length) {
      let configData = decodeURIComponent(config.data.toString());
      let conds = JSON.parse(configData.split('param=')[1]);

      conds.GLOBAL = globalInput.val();

      let params = new URLSearchParams();
      params.append('param', JSON.stringify(conds));
      config.data = params;
    }
  }
  if (config.url == '/api/cs/cp/screenresult' && vm.$route.fullPath.indexOf('/CUSTOMIZED/ORDERMANAGEADD') > -1) {
    let conds = JSON.parse(config.data.get('param'));
    conds.PAGESIZE = 9999;
    conds.fuzzyQuery = true;
    let params = new FormData();
    params.append('param', JSON.stringify(conds));
    config.data = params;
  }
  if (config.url == '/p/cs/QueryList') {
    if (/\/SYSTEM\/TABLE\//.test(vm.$route.fullPath)) {
      switch (tableName) {
        case 'PS_C_PRO_GROUP': // 组合商品
          config.url = '/api/cs/md/group/sku/QueryList';
          break;
        case 'ST_C_EXPRESS_COMPREHENSIVE_STRATEGY': // 快递综合策略
          config.url = '/api/cs/oc/oms/v1/expressComprehensive/QueryList';
          break;
        default:
          break;
      }
    }
    const changeTables = ['V_RPT_SG_B_SHARE_STORAGE', 'V_SG_B_SA_STORAGE', 'V_RPT_SG_B_STORAGE', 'V_SG_B_STO_STORE_DISTRIBUTION', 'V_RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM', 'V_COMMODITY_OPERATING_STATEMENT', 'V_SG_B_REJECT_RATION'];
    if (changeTables.includes(tableName)) {
      let configData = decodeURIComponent(config.data.toString());
      if (!configData.includes(`"isdroplistsearch":true`)) {
        switch (tableName) {
          case 'V_SG_B_STO_STORE_DISTRIBUTION':
            config.url = '/api/cs/sg/totArrivalRate/QueryList';
            break;
          case 'V_RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM':
            config.url = '/api/cs/rc/saleOrderNoSendTransferItem/QueryList';
            break;
            // 商品运营报表定制查询
          case 'V_COMMODITY_OPERATING_STATEMENT':
            config.url = '/api/cs/rc/commodityOperatingStatement/queryList';
            break;
            // 聚合仓库存-定制查询
          case 'V_RPT_SG_B_SHARE_STORAGE':
            config.url = '/api/cs/rc/shareStorage/QueryList';
            break;
            // 配销仓库存-定制查询
          case 'V_SG_B_SA_STORAGE':
            config.url = '/api/cs/rc/saStorage/QueryList';
            break;
            // 逻辑仓库存-定制查询
          case 'V_RPT_SG_B_STORAGE':
            config.url = '/api/cs/rc/storeStorage/QueryList';
            break;
          case 'V_SG_B_REJECT_RATION':
            // 拒单率报表-定制查询
            config.url = '/api/cs/sg/v1/refuse/QueryList';
            break;
          default:
            break;
        }
      }
    }
  }
  if (/\/SYSTEM\/TABLE\//.test(vm.$route.fullPath)) {
    if (config.url == '/p/cs/export') { // 定制导出
      const mergeCods = async() => {
        // 勾选ID集合+筛选条件
        const fixedcolumns = await vm.$_live_getChildComponent(vm, R3.getModuleName()).dataProcessing()
        // console.log(config, fixedcolumns)
        let params = new URLSearchParams();
        const all = new URLSearchParams(config.data)
        all.forEach((val, key) => {
          let newVal = val
          if (key == 'searchdata') {
            newVal = JSON.parse(newVal);
            if (newVal.fixedcolumns.ID && newVal.fixedcolumns.ID.length) {
              Object.assign(newVal.fixedcolumns, fixedcolumns);
            }
            newVal = JSON.stringify(newVal)
          }
          params.append(key, newVal);
        })
        config.data = params
      }

      switch (tableName) {
        case 'V_RPT_MATERIAL_SALES_SUMMARY_REPORT': // 物料销售汇总
          config.url = '/api/cs/rc/v1/rptMaterialSalesSummary/exportSaleOrderSummary';
          mergeCods()
          break;
        case 'V_RPT_SALES_DATA_REPORT_NEW': // 订单明细查询
          config.url = '/api/cs/rc/v1/rptSaleDataReport/exportOrderAndItem';
          mergeCods()
          break;
        case 'V_RPT_MATERIAL_SALES_FOR_DAY_REPORT': // 物料销售统计(日)
          config.url = '/api/cs/rc/v1/rptMaterialSalesSummary/exportSaleOrderSummaryForDay';
          mergeCods()
          break;
        case 'V_RPT_MATERIAL_SALES_FOR_MONTH_REPORT': // 物料销售统计(月)
          config.url = '/api/cs/rc/v1/rptMaterialSalesSummaryForMonth/exportSaleOrderSummary';
          mergeCods()
          break;
        case 'V_RPT_PRODUCT_LINE_SALES_FOR_DAY_REPORT': // 产品线销售统计(日)
          config.url = '/api/cs/rc/v1/rptProductLineSalesSummaryForDay/exportSaleOrderSummaryForDay';
          mergeCods()
          break;
        case 'V_RPT_PRODUCT_LINE_SALES_FOR_MONTH_REPORT': // 产品线销售统计(月)
          config.url = '/api/cs/rc/v1/rptProductLineSalesSummaryForMonth/exportSaleOrderSummary';
          mergeCods()
          break;
        case 'V_RPT_BEST_SHIPMENT_STATUS_REPORT': // 最佳出货情况报表
          config.url = '/api/cs/rc/v1/rptBestShipmentStatusReport/exportBestShipmentStatusData'
          mergeCods()
          break;
        case 'V_RPT_MATERIAL_TURNOVER_REPORT': // 物料周转报表
          config.url = '/api/cs/rc/v1/rptMaterialTurnoverReport/exportMaterialTurnoverReport'
          mergeCods()
          break;
        default:
          break;
      }
    }
  }
  if (vm.$route.fullPath.indexOf('/SYSTEM/TABLE/V_DELIVER_SETTLE_CUSTOM_DATA/249231654') > -1) {
    // 发货/结算客户数据对比
    if (config.url == '/p/cs/QueryList') {
      // 定制查询
      config.url = '/api/cs/ac/v1/deliverSettle';
    }
    if (config.url == '/p/cs/export') {
      // 定制导出
      config.url = '/api/cs/ac/v1/deliverSettleExport';
    }
  }

 // 商品运营报表定制导出
  if (vm.$route.fullPath.indexOf('/SYSTEM/TABLE/V_COMMODITY_OPERATING_STATEMENT/') > -1) {

    if (config.url == '/p/cs/export') {
      // 定制导出

      const searchData = JSON.parse(config.data.get('searchdata'))
      searchData.selectRows = window.R3.store.state[window.R3.getModuleName()] && window.R3.store.state[window.R3.getModuleName()].buttons.selectArr
      config.data.set('searchdata',JSON.stringify(searchData))
      config.url = '/api/cs/rc/commodityOperatingStatement/export';
    }
  }
 // 门店商品部报表定制导出
 if (vm.$route.fullPath.indexOf('/SYSTEM/TABLE/RC_SG_B_STO_STORE_DISTRIBUTION/') > -1) {

  if (config.url == '/p/cs/export') {
    // 定制导出
    const searchData = JSON.parse(config.data.get('searchdata'))
    searchData.selectRows = window.R3.store.state[window.R3.getModuleName()] && window.R3.store.state[window.R3.getModuleName()].buttons.selectArr
    config.data.set('searchdata',JSON.stringify(searchData))
    config.url = '/api/cs/rc/storeDistribution/export';
  }
}

  if (vm.$route.fullPath.indexOf('/SYSTEM/TABLE/SG_B_OMS_TO_WMS_CONSIGNMENT_STORAGE_CHECK/249231662') > -1) {
    // OMS与SAP寄售库存核对
    if (config.url == '/p/cs/QueryList') {
      // 定制查询
      config.url = '/api/cs/sg/consignmentStorage/QueryList';
      let selectDate = $('.SELECT_DATE input')[0].value;
      if (selectDate) {
        let configData = decodeURIComponent(config.data.toString());
        let conds = JSON.parse(configData.split('searchdata=')[1]);
        conds.fixedcolumns.SELECT_DATE = selectDate;
        let params = new URLSearchParams();
        params.append('searchdata', JSON.stringify(conds));
        config.data = params;
      }
    }
  }

  /* const filterSpecialLetterApis = [
    '/p/cs/newQueryList',
    '/p/cs/QueryList',
    '/p/cs/objectTableItem', // 明细搜索
  ]
  if (filterSpecialLetterApis.includes(config.url)) {
    // 条码过滤点
    let _params = new URLSearchParams(config.data)
    const params = new URLSearchParams()
    _params.forEach((val, key) => {
      if (key == 'searchdata') {
        const _searchdata = JSON.parse(val)
        if (_searchdata.fixedcolumns) {
          const filterColumns = ['SKU_ID', 'PS_C_SKU_ECODE', 'ECODE', 'PS_C_SKU_ID']
          filterColumns.forEach(key => {
            if (_searchdata.fixedcolumns.hasOwnProperty(key)) {
              if (typeof _searchdata.fixedcolumns[key] == 'string') {
                _searchdata.fixedcolumns[key] = _searchdata.fixedcolumns[key].replaceAll('.', '')
              }
            }
          })
        }
        // const fkids = [ 1700830048 ] // 平台店铺库存管理-条码
        if (_searchdata.isdroplistsearch && _searchdata.ak) { // 模糊搜索
          _searchdata.ak = _searchdata.ak.replaceAll('.', '')
        }
        params.append('searchdata', JSON.stringify(_searchdata));
      } else {
        params.append(key, val);
      }
    })
    config.data = params;
  } */

  // 渠道调拨单-入参把null全部换成空字符串
  if (config.url == '/p/cs/objectSave' && tableName == 'SG_B_CHANNEL_TRANSFER') {
    let configData = decodeURIComponent(config.data.toString());
    let params = new URLSearchParams();
    configData.split('&').forEach((i) => {
      const [key, val] = i.split('=');
      if (i.indexOf('data=') > -1) {
        const data = JSON.parse(val);
        for (const key_1 in data.SG_B_CHANNEL_TRANSFER) {
          if (data.SG_B_CHANNEL_TRANSFER[key_1] === null) {
            data.SG_B_CHANNEL_TRANSFER[key_1] = '';
          }
        }
        params.append(key, JSON.stringify(data));
      } else {
        params.append(key, val);
      }
      config.data = params;
    });
  }

  // JIT配货单-复制-单对象页面的接口处理
  if (tableName == 'OC_B_VIPCOM_DISTRIBUTION') {
    if (config.url == '/p/cs/getObject' || config.url == '/p/cs/objectTab') {
      if (vm.$route.query.ISCOPY == 'Y') {
        let configData = decodeURIComponent(config.data.toString());
        let params = new URLSearchParams();
        configData.split('&').forEach((i) => {
          let [key, val] = i.split('=');
          if (key == 'objid') {
            val = vm.$route.query.OID;
          }
          params.append(key, val);
        });
        params.append('ISCOPY', 'Y');
        config.data = params;
      }
      localStorage.setItem('objectTabRequest', config.data); // 详情页做判断用
    }
    if (vm.$route.query.ISCOPY == 'Y' && (config.url == '/p/cs/objectSave' || config.url == '/p/cs/objectAdd' || config.url == '/api/cs/vip/distribution/save')) {
      config.url = '/api/cs/vip/distribution/v1/copyDistribution';
      let params = new URLSearchParams();
      /* let configData = decodeURIComponent(config.data.toString());
      configData.split('&').forEach((i) => {
        let [key, val] = i.split('=');
        if (key == 'objid') {
          val = -1;
        }
        params.append(key, val);
      }); */
      for (let key in config.data) {
        let val = config.data[key]
        if (key == 'objid') {
          val = -1;
        }
        params.append(key, JSON.stringify(val));
      }
      params.append('iscopy', 'Y');
      params.append('originalId', vm.$route.query.OID);
      config.data = params;
    }
  }

  const curUrl = config.url;
  const changeApi = require('./config/changeR3Api').default;
  if (Object.keys(changeApi).includes(curUrl)) {
    config.url = changeApi[curUrl];
  }

  return config;
});

R3.network.axios.interceptors.response.use((config) => {
  const configData = config.data;

  interceptorsModule.category.response(config) // defined商品品类
  interceptorsModule.SG_B_STO_X_RESULT.response(config) // 逻辑出库单/逻辑入库单新增
  interceptorsModule.permission.response(config) // 数据权限

  if (configData && configData.datas) {
    const table = configData.datas.table; // 表名
    //  唯品会缺货统计 、 唯品会发货时效跟踪报表、分货单明细查询、多渠道调拨单结果查询
    const tableArr = ['V_RPT_VIP_OUTSTOCK', 'V_RPT_VIP_DELIVER_OVERTIME_TRACK', 'V_SG_B_SHARE_ALLOCATION', 'V_SG_B_STO_MULTI_CHANNEL_TRANSFER_QUERY_RESULT'];
    if (tableArr.indexOf(table) > -1) {
      if (config.config.url === '/p/cs/getTableQuery') {
        // 为了能显示导出按钮（因为这个页面没有单对象，不希望双击进入详情页，所以 读写规则配置的是M,就没办法配置导出按钮了，只能前端处理一下接口返回的数据，让导出按钮显示）
        const cmds = configData.tabcmd.cmds || []; // 按钮数组
        cmds.forEach((item, index) => {
          if (item === 'actionEXPORT') {
            configData.tabcmd.prem[index] = true; // 显示导出按钮
          }
        });
      }
    }
  }

  const { tableName } = vm.$route.params;

  if (config.config.url == '/api/cs/sg/storeDistribution/QueryList') {
    if (config.data.code == 0) {
      config.data.datas.defaultrange = localStorage.getItem('storeDistributionPageSize')
    }
  }

  if (config.config.url == '/p/cs/objectTableItem' && ['SG_B_STO_TRANSFER', 'SG_B_CHANNEL_TRANSFER'].includes(tableName)) {
    vm.$store.state.omsStore.objectTableItem = -new Date();
  }

  if (tableName == 'OC_B_VIPCOM_DISTRIBUTION') {
    /* 1.JIT复制的配货单 可编辑字段
      1）单据状态：缺货["2"] &是否复制=是
      主表可编辑字段：物流公司、配送方式、发货实体仓、备注信息
      明细：只保留 条码，数量字段，均必填
      明细按钮：保存，删除明细，导出
      2）单据状态：占单成功["8"] &是否复制=是
      主表可编辑字段：物流公司、配送方式、备注信息
      明细：只保留 条码，数量字段，均必填
      明细按钮：导出
      3）单据状态：不等于（缺货，占单成功） &是否复制=是
      主表可编辑字段：均不能编辑
      明细：只保留 条码，数量字段，均必填
      明细按钮：导出
    2.不管选择什么状态的单据进行复制后，进入到复制页面都要满足以下条件
      主表可编辑字段：唯品会入库单[OUTSTORAGE_CODE]、是否禁空[IS_AIR_EMBARGO]、物流公司[CP_C_LOGISTICS]、配送方式[DELIVERY_METHOD]、发货实体仓[CP_C_PHY_WAREHOUSE]、备注信息[REMARK]
      明细：只保留 条码，数量字段，均必填
      明细按钮：保存，删除明细，导出 */
    const itemOnlyTow = () => {
      if (config.config.url == '/p/cs/inputForitem') {
        const showArr = ['PS_C_SKU_ID', 'TOT_QTY_OUT'];
        configData.data.inpubobj = configData.data.inpubobj.filter((i) => showArr.includes(i.colname));
      }
    };
    const noImport = () => {
      if (config.config.url == '/p/cs/objectTab') {
        const req = localStorage.getItem('objectTabRequest');
        let reqStr = decodeURIComponent(req.toString());
        if (reqStr.includes('OC_B_VIPCOM_DISTRIBUTION_ITEM')) {
          configData.data.tabcmd.prem[2] = false; // actionIMPORT
        }
      }
    };
    const onlyExport = () => {
      if (config.config.url == '/p/cs/objectTab') {
        const req = localStorage.getItem('objectTabRequest');
        let reqStr = decodeURIComponent(req.toString());
        if (reqStr.includes('OC_B_VIPCOM_DISTRIBUTION_ITEM')) {
          configData.data.tabcmd.prem[0] = false; // actionMODIFY
          configData.data.tabcmd.prem[1] = false; // actionDELETE
          configData.data.tabcmd.prem[2] = false; // actionIMPORT
        }
      }
    };
    const canEdit = () => {
      // 放开保存按钮 及 去掉所有 表单不可编辑限制
      if (config.config.url == '/p/cs/objectTab') {
        const req = localStorage.getItem('objectTabRequest');
        let reqStr = decodeURIComponent(req.toString());
        if (reqStr.includes('OC_B_VIPCOM_DISTRIBUTION')) {
          configData.data.tabcmd.prem[0] = true; // actionADD
          configData.data.tabcmd.prem[1] = true; // actionMODIFY
          configData.data.objreadonly = false;
        }
      }
    };
    const readonlyFn = (editArr, disabledArr) => {
      if (config.config.url == '/p/cs/getObject') {
        configData.data.addcolums[0].childs.forEach((i) => {
          if (editArr.includes(i.colname)) {
            i.readonly = false;
          } else if (disabledArr.includes(i.colname)) {
            i.readonly = true;
          }
        });
      }
    };
    if (config.config.url == '/p/cs/getObject') {
      let obj = configData.data.addcolums[0].childs.find((i) => i.colname == 'IS_COPY')
      let statusObj = configData.data.addcolums[0].childs.find((i) => i.colname == 'STATUS')
      const isCopyObj = obj && obj.valuedata;
      const STATUS = statusObj && statusObj.valuedata;
      localStorage.setItem('CUS_OC_B_VIPCOM_DISTRIBUTION', JSON.stringify({ isCopyObj, STATUS }));
    }
    const { isCopyObj, STATUS } = JSON.parse(localStorage.getItem('CUS_OC_B_VIPCOM_DISTRIBUTION') || JSON.stringify({}));
    if (isCopyObj == '1') {
      itemOnlyTow();
      if (STATUS == '2') {
        // 缺货
        console.log('STATUS::', 2);
        canEdit();
        const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'CP_C_PHY_WAREHOUSE', 'REMARK'];
        const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE'];
        readonlyFn(editArr, disabledArr);
        noImport();
      } else if (STATUS == '8') {
        // 占单成功
        console.log('STATUS::', 8);
        canEdit();
        const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'REMARK'];
        const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE', 'CP_C_PHY_WAREHOUSE_ID'];
        readonlyFn(editArr, disabledArr);
        onlyExport();
      } else {
        onlyExport();
      }
    }
    if (vm.$route.query.ISCOPY == 'Y') {
      itemOnlyTow();
      const editArr = ['OUTSTORAGE_CODE', 'IS_AIR_EMBARGO', 'CP_C_LOGISTICS', 'DELIVERY_METHOD', 'CP_C_PHY_WAREHOUSE', 'REMARK'];
      const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE'];
      readonlyFn(editArr, disabledArr);
      if (config.config.url == '/p/cs/objectTab') {
        const req = localStorage.getItem('objectTabRequest');
        let reqStr = decodeURIComponent(req.toString());
        if (reqStr.includes('OC_B_VIPCOM_DISTRIBUTION_ITEM')) {
          configData.data.tabcmd.prem[2] = false; // actionIMPORT
        }
        if (reqStr.includes('OC_B_VIPCOM_DISTRIBUTION') && reqStr.includes('ISCOPY=Y')) {
          configData.data.tabcmd.prem[0] = true; // actionADD
          configData.data.tabcmd.prem[1] = true; // actionMODIFY
          configData.data.objreadonly = false;
        }
      }
      if (config.config.url == '/p/cs/objectTableItem') {
        // 2016009 【唯品会JIT配货单】复制有明细的配货单，复制页面无须带入明细
        // if (configData.datas.tabname == 'OC_B_VIPCOM_DISTRIBUTION_ITEM') {
        configData.datas.row = [];
        configData.datas.rowCount = 0;
        // }
      }
    }
    if (config.config.url == '/api/cs/vip/distribution/v1/copyDistribution') {
      if (configData.code == 0) {
        if (configData.data && configData.data.objid) {
          const _id = configData.data.objid;
          vm.$store.commit('global/tabOpen', {
            type: 'V',
            url: `/SYSTEM/TABLE_DETAIL/V/OC_B_VIPCOM_DISTRIBUTION/24733/${_id}`,
          });
        } else {
          $fcError(t('没有返回新单子的ID！'));
        }
      }
    }
  }
  if (config.config.url == '/p/cs/getObject' && tableName == 'AC_F_LOGISTICS_FEE_DIFF') {
    const item1 = configData.data.addcolums[0].childs[0];
    item1.webconf.drpFilterMode = true; // 给drp组件添加类似mrp组件的filterMode功能，元数据配置 webconf: {"drpFilterMode": true}
    // item1.display = 'defined'
    /* {
          formRequest: {  // 配置到主控字段
            type: 1, // 等于1 代表 input checkbox；等于0 代表 下拉框和外键等
            refcolumn:"LOGISTICS_NUMBER", // 需要向后台传参字段，多字段用逗号隔开
            url:'/p/cs/testyayay' // 后台服务端接口
          }
      } */
    console.log('addcolums::', config.data.data.addcolums);
  }

  if (configData && configData.datas) {
    const table = configData.datas.table; // 表名
    //  唯品会缺货统计 、 唯品会发货时效跟踪报表、分货单明细查询
    const tableArr = ['V_RPT_VIP_OUTSTOCK', 'V_RPT_VIP_DELIVER_OVERTIME_TRACK', 'V_SG_B_SHARE_ALLOCATION'];
    if (tableArr.indexOf(table) > -1) {
      if (config.config.url === '/p/cs/getTableQuery') {
        // 为了能显示导出按钮（因为这个页面没有单对象，不希望双击进入详情页，所以 读写规则配置的是M,就没办法配置导出按钮了，只能前端处理一下接口返回的数据，让导出按钮显示）
        const cmds = configData.tabcmd.cmds || []; // 按钮数组
        cmds.forEach((item, index) => {
          if (item === 'actionEXPORT') {
            configData.tabcmd.prem[index] = true; // 显示导出按钮
          }
        });
      }
    }
    // 商品款号列表-商品编码字段、品牌匹配表列表-解析位数字段、OMS与SAP寄售库存核对-查询时间
    if (['PS_C_PRO', 'PS_C_BRAND_MATCH', 'SG_B_OMS_TO_WMS_CONSIGNMENT_STORAGE_CHECK'].includes(table) && config.config.url === '/p/cs/getTableQuery') {
      configData.datas.dataarry.forEach((item) => {
        if (['ECODE', 'PARSE_NUMBER'].includes(item.colname)) {
          delete item.display;
        }
        if (['SELECT_DATE'].includes(item.colname)) {
          item.display = 'defined';
        }
      });
    }
  }
  if (config.config.url == '/p/cs/objectAdd' && ['CP_C_SHOP', 'PS_C_PRO', 'PS_C_SKU'].includes(tableName)) {
    // 平台店铺档案(扩展属性)、商品SPU(商品属性)、商品SKU(销售属性)
    if (config.data.code == 0 && config.data.data && config.data.data.objid) {
      const form = JSON.parse(sessionStorage.getItem('cpCShop_form'));
      let api = '';
      const params = {
        ID: config.data.data.objid,
        data: form,
      };
      let hasAdd = Object.values(form).some((i) => i != '' && i != null);
      if (hasAdd) {
        switch (tableName) {
          case 'CP_C_SHOP': // 平台店铺档案
            api = 'saveExtendInfo';
            break;
          case 'PS_C_PRO': // 商品SPU
          case 'PS_C_SKU': // 商品SKU
            api = 'saveExtendInfoForGoods';
            params.tableName = tableName;
          default:
            break;
        }
        $service.commodityCenter[api](params);
      }
    }
  }



  if (/\/(ORDERMANAGEADD|ORDERMANAGER|CUS_ST_C_STORAGE_SOURCING_STRATEGY_TOB)/.test(vm.$route.fullPath) && config.config.url == '/p/cs/newQueryList') {
    /**
     * 1. 零售列表/新增-发货仓库 外键关联表格数据只显示实体仓库编码、实体仓库名称 - 夏彬
     * 2. TOB寻源策略定义-实体仓 只显示实体仓库编码、实体仓库名称
     */
    let configData = decodeURIComponent(config.config.data.toString());
    if (configData.includes('167640') || configData.includes('176316')) {
      config.data.datas.tabth = config.data.datas.tabth.filter(i => ['ID', 'ECODE', 'ENAME'].includes(i.colname));
    }
  }

  return config;
});

class CustomizedConfig {
  // static #beforeEach = beEach;
  static #STLD = {
    defined: layoutModule.standardTableListdefind,
  };
  static #STLC = mixinsModule.standardTableListsCustomize;
  static #VTDC = mixinsModule.verticalTableDetailCustomize;
  static #TDCM = mixinsModule['standardTable/mixin'];
  static #custommizeMain = configModule.customizedPanelConfig;
  static #subTableConfig = configModule.subTableConfig;
  static #customizedModal = configModule.customizedModalConfig;
  static #customizedPage = configModule.customizedPageConfig;
  static #customizeWaterMarkConfig = configModule.customizedWatermarkConfig;
  static #customizedExternalTreeDatas = configModule.externalTreeDatasConfig;
  static #filterUrlConfig = configModule.filterUrlConfig;
  static #filterUrlForNetworkSc = configModule.filterUrlForNetwork;
  static #orderDetailConnector = configModule.orderDetailConnector;
  static #labelList = configModule.labelList;
  static #orderLogo = configModule.orderLogo;
  static #cssHandle = configModule.cssHandle;
  static #importTableConfig = configModule.importTableConfig;
  static #cusImage = configModule.globalComponentConfig.cusImage;
  static #cusGlobalComponent = configModule.globalComponentConfig.cusGlobalComponent;
  static #customizedService = customizedService;
  static #downLoadAllConfig = downLoadAllConfig;
  static #appLayoutSc = configModule.appLayout;

  /* 初始化项目的配置项，用于挂载 */
  static #funBtn = configModule.funBtnConfig;
  static #dropDownBtn = configModule.dropDownConfig;
  static #cusValidate = configModule.validateConfig;
  /* ------------ 挂载项 start ------------- */

  /* static get beforeEach() {
		return this.#beforeEach;
	} */
  static get STLD() {
    return this.#STLD;
  }
  static get Rule() {
    return this.#cusValidate;
  }
  static get STLC() {
    return this.#STLC;
  }
  static get VTDC() {
    return this.#VTDC;
  }
  static get TDCM() {
    return this.#TDCM;
  }
  static get cssHandleUtils() {
    return this.#cssHandle;
  }
  static get BtnConfig() {
    return this.#funBtn;
  }
  static get dropDownBtn() {
    return this.#dropDownBtn;
  }
  /* ------------ 挂载项 end ------------- */

  constructor() {
    // this.initConfig = new InitAppConfig();
    // console.log('hello CustomizedConfig');
  }
  static get formDefined() {
    return this.#custommizeMain; // defined组件的配置项
  }
  // subTable组件的配置项(有用到，不准删！！！)
  static get subTableConfig() {
    return this.#subTableConfig;
  }
  static editSubTableConfig(configItem = {}) {
    for (const centerKey in configItem) {
      if (!Object.keys(configItem[centerKey])) return;
      for (const key in configItem[centerKey]) {
        if (this.#subTableConfig[centerKey]) {
          this.#subTableConfig[centerKey][key] = configItem[centerKey][key];
        } else {
          this.#subTableConfig[centerKey] = configItem[centerKey];
        }
      }
      this.#subTableConfig[key] = configItem[key];
    }
    return this.#subTableConfig;
  }

  // R3.launchApplication.image配置
  static get image() {
    return this.#cusImage;
  }
  static editImage(configItem = {}) {
    for (const key in configItem) {
      this.#cusImage[key] = configItem[key];
    }
    return this.#cusImage;
  }

  // R3.launchApplication.globalComponent配置
  static get globalComponent() {
    return this.#cusGlobalComponent;
  }
  static editGlobalComponent(configItem = {}) {
    for (const key in configItem) {
      this.#cusGlobalComponent[key] = configItem[key];
    }
    return this.#cusGlobalComponent;
  }

  // downLoadAll组件的配置项
  static get cusDownLoadAllConfig() {
    return this.#downLoadAllConfig;
  }
  static editDownLoadAllConfig(configItem = {}) {
    for (const key in configItem) {
      this.#downLoadAllConfig[key] = configItem[key];
    }
    return this.#downLoadAllConfig;
  }

  // 定制弹窗配置项
  static get cusModalConfig() {
    return this.#customizedModal;
  }
  static editCusModalConfig(configItem = {}) {
    for (const key in configItem) {
      this.#customizedModal[key] = configItem[key];
    }
    return this.#customizedModal;
  }

  // 定制页面配置项
  static get cusPageConfig() {
    return this.#customizedPage;
  }
  static editCusPageConfig(configItem = {}) {
    if (!Object.keys(configItem)) return;
    for (const key in configItem) {
      this.#customizedPage[key] = configItem[key];
    }
    return this.#customizedPage;
  }

  // 树结构配置项
  static get cusExternalTreeDatas() {
    let list = this.#customizedExternalTreeDatas;
    return configModule.configHandle.handerTreeList(list);
  }
  static editCusExternalTreeDatas(config = []) {
    /**
     * 封装逻辑：
     * 1. 接收参数为数组类型的配置，如 src/config/config/externalTreeDatas.config.js
     * 2. 将参数拼接到上述数组
     * 3. 赋值给 #customizedExternalTreeDatas
     * 4. get()方法会去调用处理树解构的方法'handerTreeList'
     */
    /* for (const key in configItem) {
			this.#customizedExternalTreeDatas[key] = configItem[key];
		} */
    let res = JSON.parse(JSON.stringify(this.#customizedExternalTreeDatas));
    if (config.length) {
      this.#customizedExternalTreeDatas = res.concat(config);
    }
    return this.#customizedExternalTreeDatas;
  }

  // 接口配置项
  static get cusService() {
    return this.#customizedService;
  }
  static editCusService(configItem = {}) {
    for (const centerKey in configItem) {
      if (!Object.keys(configItem[centerKey])) return;
      for (const apiKey in configItem[centerKey]) {
        if (this.#customizedService[centerKey]) {
          // 存在此中心则修改apiKey
          this.#customizedService[centerKey][apiKey] = configItem[centerKey][apiKey];
        } else {
          // 不存在此中心则直接新增
          this.#customizedService[centerKey] = configItem[centerKey];
        }
      }
    }
    return this.#customizedService;
  }

  // 订单管理专用label配置项.[]
  static get cusLabelList() {
    return this.#labelList;
  }
  static editCusLabelList(configItem = []) {
    const compareLable = configModule.configHandle.compareObjectFunction('label');
    for (const x in configItem) {
      for (const y in this.#labelList) {
        if (compareLable(configItem[x], this.#labelList[y])) {
          // lable相同则替换
          this.#labelList[y] = configItem[x];
        } else {
          // 反之，新增
          this.#labelList.push(configItem[x]);
        }
      }
    }
    return this.#labelList;
  }

  // orderLogo配置项
  static get cusOrderLogo() {
    return this.#orderLogo;
  }
  static editCusOrderLogo(configItem = {}) {
    for (const key in configItem) {
      this.#orderLogo[key] = configItem[key];
    }
    return this.#orderLogo;
  }

  // 水印配置项
  static get cusWaterMarkConfig() {
    return this.#customizeWaterMarkConfig;
  }
  static editCusWaterMarkConfig(configItem = {}) {
    for (const key in configItem) {
      this.#customizeWaterMarkConfig[key] = configItem[key];
    }
    return this.#customizeWaterMarkConfig;
  }

  // 过滤报错接口配置项 的脚本（不提供修改）
  static get filterUrlForNetworkScript() {
    return this.#filterUrlForNetworkSc;
  }

  static get appLayoutScript() {
    return this.#appLayoutSc;
  }

  // 过滤报错接口配置项
  static get cusFilterUrlConfig() {
    return this.#filterUrlConfig;
  }
  static editCusFilterUrlConfig(configItem = {}) {
    for (const key in configItem) {
      this.#filterUrlConfig[key] = configItem[key];
    }
    return this.#filterUrlConfig;
  }

  // 订单详情-半定制-配置项
  static get connector() {
    return this.#orderDetailConnector;
  }
  static editConnector(configItem = {}) {
    for (const key in configItem) {
      this.#orderDetailConnector[key] = configItem[key];
    }
    return this.#orderDetailConnector;
  }

  // 导入接口、下载模板的模板地址（importTable.vue中需要的配置项）
  static get cusImport() {
    return this.#importTableConfig;
  }
  static editCusImport(configObj = {}) {
    if (!Object.keys(configObj)) return;
    for (const tableWebnameKey in configObj) {
      this.#importTableConfig[tableWebnameKey] = configObj[tableWebnameKey];
    }
    return this.#importTableConfig;
  }

  static editConfig(config, configItem = {}) {
    for (const key in configItem) {
      this[config][key] = configItem[key];
    }
    return this[config];
  }
}
// console.log(new CustomizedConfig());
// console.clear();
const Custom = {
  beforeEach: configModule.configHandle.beforeEach,
  ...layoutModule,
  STLD: CustomizedConfig.STLD,
  Rule: CustomizedConfig.Rule,
  STLC: CustomizedConfig.STLC,
  VTDC: CustomizedConfig.VTDC,
  TDCM: CustomizedConfig.TDCM,
  ExMixin: require('./minxin/extraMixin'),
  cssHandleUtils: CustomizedConfig.cssHandleUtils,
  BtnConfig: CustomizedConfig.BtnConfig,
  dropDownBtn: CustomizedConfig.dropDownBtn,
  image: CustomizedConfig.image,
  setImage: (v) => CustomizedConfig.editImage(v),
  globalComponent: CustomizedConfig.globalComponent,
  setGlobalComponent: (v) => CustomizedConfig.editGlobalComponent(v),
  cusModalConfig: CustomizedConfig.cusModalConfig,
  setCusModalConfig: (v) => CustomizedConfig.editCusModalConfig(v),
  cusPageConfig: CustomizedConfig.cusPageConfig,
  setCusPageConfig: (v) => CustomizedConfig.editCusPageConfig(v),
  cusExternalTreeDatas: CustomizedConfig.cusExternalTreeDatas,
  setCusExternalTreeDatas: (v) => CustomizedConfig.editCusExternalTreeDatas(v),
  formDefined: CustomizedConfig.formDefined,
  subTableConfig: CustomizedConfig.subTableConfig,
  setSubTableConfig: (v) => CustomizedConfig.editSubTableConfig(v),
  cusDownLoadAllConfig: CustomizedConfig.cusDownLoadAllConfig,
  setDownLoadAllConfig: (v) => CustomizedConfig.editDownLoadAllConfig(v),
  cusService: CustomizedConfig.cusService,
  setCusService: (v) => CustomizedConfig.editCusService(v),
  cusLabelList: CustomizedConfig.cusLabelList,
  setCusLabelList: (v) => CustomizedConfig.editCusLabelList(v),
  cusOrderLogo: CustomizedConfig.cusOrderLogo,
  setCusOrderLogo: (v) => CustomizedConfig.editCusOrderLogo(v),
  cusWaterMarkConfig: CustomizedConfig.cusWaterMarkConfig,
  setCusWaterMarkConfig: (v) => CustomizedConfig.editCusWaterMarkConfig(v),
  filterUrlForNetworkScript: CustomizedConfig.filterUrlForNetworkScript,
  cusFilterUrlConfig: CustomizedConfig.cusFilterUrlConfig,
  setCusFilterUrlConfig: (v) => CustomizedConfig.editCusFilterUrlConfig(v),
  connector: CustomizedConfig.connector,
  setConnector: (v) => CustomizedConfig.editConnector(v),
  cusImport: CustomizedConfig.cusImport,
  editCusImport: (v) => CustomizedConfig.editCusImport(v),
  editConfig: (v) => CustomizedConfig.editConfig(v),
  appLayoutScript: CustomizedConfig.appLayoutScript,
};
// export default CustomizedConfig;
export default Custom;
